export default __webpack_public_path__ + "static/premier-defi-191adf67e743ddcd7a3082dd5b1de3e1.png";